import { DataBuilderHttpError } from './errors';

export async function fetchJson<T>(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<T> {
  const headers = new Headers(init?.headers);
  if (!headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(input, {
    credentials: 'include',
    ...init,
    headers,
  });

  if (!response.ok) {
    const message = await response.text();
    const responseRequestId =
      response.headers.get('x-request-id') ??
      response.headers.get('request-id');
    throw new DataBuilderHttpError(
      message || 'Unknown error',
      response.status,
      response.statusText,
      responseRequestId ?? ''
    );
  }

  if (response.status === 204) {
    return undefined as T;
  }

  // Some endpoints (e.g. /update-settings) reply 200/201 with an empty body.
  // Reading text first avoids response.json() throwing on a zero-length body.
  const text = await response.text();
  return (text ? JSON.parse(text) : undefined) as T;
}
